import { BusyService } from "../../services/busy-service";
import { WebApiService } from "../../services/web-api-service";
import { bindable, bindingMode, autoinject } from "aurelia-framework";
import { SecurityService } from "../../services/security-service";

@autoinject()
export class MillDropdown {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) selectedMillCode: string = "All";
    millCodes: Array<string> = [];

    constructor(
        private api: WebApiService,
        private securityService: SecurityService,
        private busyService: BusyService
    ) { }

    attached() {
        if (!this.millCodes.length) {
            this.loadMills();
        }
    }

    loadMills() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                let response = JSON.parse(result.response);
                this.millCodes = response.map((item) => {
                    return item.code;
                }).filter(millCode => {
                    if (this.securityService.user.millCodes.length == 0)
                        return true;
                    else
                        return this.securityService.user.millCodes.find(o => o == millCode);
                });
            })
            .finally(() => {
                this.busyService.off();
            });
    }

}

